// extracted by mini-css-extract-plugin
module.exports = {"filterWrapper":"filter_filterWrapper__Kg9vU","search":"filter_search__tVFd_","filter":"filter_filter__9mNj8 typography_bodyFont__Sn75r","filterLabel":"filter_filterLabel___1HNX"};